import { render, staticRenderFns } from "./KeepingFitWell.vue?vue&type=template&id=655b27b2&scoped=true&"
import script from "./KeepingFitWell.vue?vue&type=script&lang=js&"
export * from "./KeepingFitWell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655b27b2",
  null
  
)

export default component.exports